// Golf Elite club-account auth — email/password (a NEW, additive tier). Does not
// touch the existing admin PIN gate or the member Google/Apple auth.
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth'
import { app } from './firebase.js'

export const platformAuth = getAuth(app)
export function signUpEmail(email, password) { return createUserWithEmailAndPassword(platformAuth, email, password) }
export function logInEmail(email, password) { return signInWithEmailAndPassword(platformAuth, email, password) }
export function logOutPlatform() { return signOut(platformAuth) }
export function onPlatformAuth(cb) { return onAuthStateChanged(platformAuth, (u) => cb(u || null)) }
